<template>
  <div>
    <div id="chart">
      <apexchart type="bar" height="350" :options="chartOptions" :series="series1"></apexchart>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'PicklBarChart',
  components: {
    apexchart: VueApexCharts
  },
  props: {
    ProductPurchaseSummaryData: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      chartOptions: {
        chart: {
          type: 'bar',
          height: 350,
          horizontal: true
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            borderRadiusApplication: 'end',
            horizontal: true
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: []
        }
      },
      series1: []
    }
  },
  mounted () {
    this.updateChartData()
  },
  methods: {
    updateChartData () {
      if (this.ProductPurchaseSummaryData && this.ProductPurchaseSummaryData.length) {
        const categories = this.ProductPurchaseSummaryData.map(item => item.name)
        const data = this.ProductPurchaseSummaryData.map(item => item.user_pickls_count)

        this.chartOptions = {
          ...this.chartOptions,
          xaxis: {
            ...this.chartOptions.xaxis,
            categories
          }
        }

        this.series1 = [{
          name: 'Buy Me Count',
          data
        }]
      }
    }
  },
  watch: {
    ProductPurchaseSummaryData (newVal) {
      if (newVal) {
        this.updateChartData()
      }
    }
  }
}
</script>

<style scoped>
#chart {
  max-width: 100%;
}
</style>
